import { Download, Film, X } from 'lucide-react';
import { useState } from 'react';
import { detectPlatform } from '../lib/media';
import { forget, saveFromButton, sizeLabel, usePendingRecordings } from '../lib/recordingFiles';
import { Button } from './ui';

/**
 * Phones and tablets: «your recording is ready» with a Save button that opens the share sheet.
 * A card, not a modal: the meeting goes on while it waits. It lives at the top of the app, so it
 * stays after leaving the meeting.
 */
export function PendingRecordingsDialog() {
  const items = usePendingRecordings();
  const [confirmDiscard, setConfirmDiscard] = useState(false);
  const [busy, setBusy] = useState(false);
  const item = items[0];
  if (!item) return null;
  const ios = detectPlatform().startsWith('ios');
  const isVideo = item.file.type === 'video/mp4';

  return (
    <section className="rec-ready-card" role="dialog" aria-modal="false" aria-labelledby="rec-ready-title">
      <header>
        <Film size={22} />
        <h2 id="rec-ready-title">Tu grabación está lista</h2>
        <button type="button" className="icon-btn" aria-label="Descartar grabación" onClick={() => setConfirmDiscard(true)}>
          <X size={18} />
        </button>
      </header>
      <p className="rec-ready-name">
        <strong>{item.file.name}</strong> · {sizeLabel(item.file.size)}
      </p>
      {confirmDiscard ? (
        <p className="callout callout-warning">Si la descartas se pierde: solo existe en este dispositivo.</p>
      ) : ios ? (
        <p>
          Toca <strong>«Guardar grabación»</strong> y elige {isVideo ? <><strong>«Guardar video»</strong> (aparecerá en Fotos) o </> : null}
          <strong>«Guardar en Archivos»</strong>. También puedes enviarla por WhatsApp, Mail o AirDrop.
        </p>
      ) : (
        <p>
          Toca <strong>«Guardar grabación»</strong> y elige dónde: Archivos, Google Drive, Fotos, WhatsApp… Si tu teléfono no muestra opciones,
          se guarda en <strong>Descargas</strong>.
        </p>
      )}
      {items.length > 1 && <p className="hint">Hay {items.length} grabaciones pendientes de guardar.</p>}
      <div className="rec-ready-actions">
        {confirmDiscard ? (
          <>
            <Button variant="ghost" onClick={() => setConfirmDiscard(false)}>
              No, volver
            </Button>
            <Button
              variant="danger"
              onClick={() => {
                forget(item.id);
                setConfirmDiscard(false);
              }}
            >
              Descartar grabación
            </Button>
          </>
        ) : (
          <Button
            variant="primary"
            disabled={busy}
            onClick={async () => {
              setBusy(true);
              try {
                await saveFromButton(item);
              } finally {
                setBusy(false);
              }
            }}
          >
            <Download size={16} /> Guardar grabación
          </Button>
        )}
      </div>
    </section>
  );
}
